/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_008: Question = {
  id: 'pres-008-superficie-milieux-terrestres',
  oldId: '22',
  title: 'Superficie totale des milieux naturels terrestres',
  number: '2.8',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 4,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.HECTARE,
    },
  ],
};
const question_pres_008__v3: Question = {
  ...question_pres_008,
  number: '2.7',
  slots: [
    {
      ...question_pres_008.slots[0],
      unit: SlotUnit.PERCENTAGE,
    },
  ],
};

export const question_pres_008_v2: Question = question_pres_008;
export const question_pres_008_v3: Question = question_pres_008__v3;
